import React from 'react';
import ReactDOM from 'react-dom/client';
import { Agentation } from 'agentation';
import { App } from './App';
import { APP_TITLE } from './config/branding';
// Self-hosted DM Sans (Interstate DS body/display face) — bundled so the strict
// CSP (`style-src 'self'`) serves it same-origin, instead of the blocked Google
// Fonts CDN. Weights match --genai-font-body/display in tokens.css (400–700).
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import './styles/tokens.css';
import './styles/theme.css';
import './styles/components.css';

// Env-driven browser-tab title (AC-4.1): the index.html <title> carries the default
// "Specs-Ray: SDD Maturity Dashboard" pre-JS; the prod build (VITE_APP_TITLE set)
// rebrands it to "Specs-Ray: AI Maturity Dashboard" at startup. The wordmark is fixed.
document.title = `Specs-Ray: ${APP_TITLE}`;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    {import.meta.env.DEV && <Agentation />}
  </React.StrictMode>
);
